const Config = {
  API_BASE_URL: "https://api.rotiey.com/api/f",

  // ---------- GETTERS ----------
  getToken: () => {
    const sessiondata = sessionStorage.getItem("AuthToken");
    return sessiondata ? JSON.parse(sessiondata) : null;
  },
  getId: () => {
    const sessiondata = sessionStorage.getItem("LoginId");
    return sessiondata ? JSON.parse(sessiondata) : null;
  },
  getUserPhone: () => {
    const sessiondata = sessionStorage.getItem("LoginPhone");
    return sessiondata ? JSON.parse(sessiondata) : null;
  },
  getUserName: () => {
    const sessiondata = sessionStorage.getItem("LoginName");
    return sessiondata ? JSON.parse(sessiondata) : null;
  },
  getUserEmail: () => {
    const sessiondata = sessionStorage.getItem("LoginEmail");
    return sessiondata ? JSON.parse(sessiondata) : null;
  },
  getUserIsLogin: () => {
    const sessiondata = sessionStorage.getItem("IsLogin");
    return sessiondata ? JSON.parse(sessiondata) : null;
  },
  getStateId: () => {
    const sessiondata = localStorage.getItem("userLocation");
    const stateId = sessiondata ? JSON.parse(sessiondata) : null;
    return stateId ? stateId.state : null;
  },
  getCountryId: () => {
    const sessiondata = localStorage.getItem("userLocation");
    const countryId = sessiondata ? JSON.parse(sessiondata) : null;
    return countryId ? countryId.countryCode : null;
  },
  // ---------- CLEAR ----------
  clearUserSession: () => {
    sessionStorage.removeItem("AuthToken");
    sessionStorage.removeItem("LoginId");
    sessionStorage.removeItem("LoginPhone");
    sessionStorage.removeItem("LoginName");
    sessionStorage.removeItem("LoginEmail");
    sessionStorage.removeItem("IsLogin");
  },
  
  // ---------- HANDLE UNAUTHORIZED ----------
  handleUnauthorized: () => {
    Config.clearUserSession();
    window.location.href = '/';
  }
};

export default Config;
